import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Loader2, Check } from "lucide-react";
import { api, setMeta } from "@/lib/museo";
import { Footer } from "@/components/Footer";
import { toast } from "sonner";

export default function Segnala() {
  const [numero, setNumero] = useState("");
  const [motivo, setMotivo] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  setMeta({
    title: "Segnala un messaggio — Il Museo delle Promesse",
    canonical: `${window.location.origin}/segnala`,
    ogType: "website",
  });

  const canSubmit = numero.trim() && motivo.trim() && !loading;

  const submit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setLoading(true);
    try {
      await api.post("/reports", { numero: numero.trim(), motivo: motivo.trim(), email: email.trim() });
      setSent(true);
      toast.success("Segnalazione inviata");
    } catch {
      toast.error("Si è verificato un errore. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative z-10 min-h-screen flex flex-col">
      <div className="flex-1 max-w-2xl mx-auto px-6 md:px-12 pt-16 md:pt-24 w-full">
        <Link
          to="/"
          data-testid="segnala-back-home"
          className="inline-flex items-center gap-2 text-sm text-museo-muted hover:text-museo-accent transition-colors mb-12 uppercase tracking-[0.15em]"
        >
          <ArrowLeft className="w-4 h-4" /> Torna al museo
        </Link>
        <h1 className="font-serif text-4xl md:text-5xl text-museo-text mb-6">Segnala una promessa</h1>
        <p className="text-museo-muted font-light mb-10 leading-relaxed">
          Se ritieni che una promessa violi le regole del museo, segnalacela. La esamineremo al più presto.
        </p>

        {sent ? (
          <div data-testid="report-success" className="flex flex-col items-center gap-4 py-12 text-center">
            <Check className="w-10 h-10 text-museo-accent" />
            <p className="font-serif text-2xl text-museo-text">Grazie per la tua segnalazione.</p>
            <p className="text-sm text-museo-muted font-light">La esamineremo al più presto.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-8">
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] text-museo-muted mb-3">Numero promessa</label>
              <input
                data-testid="report-numero-input"
                value={numero}
                onChange={(e) => setNumero(e.target.value)}
                placeholder="es. 000184"
                className="w-full bg-transparent border-b border-museo-border text-museo-text text-lg py-3 focus:border-museo-accent focus:outline-none placeholder:text-museo-muted/40 font-mono"
              />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] text-museo-muted mb-3">Motivo della segnalazione</label>
              <textarea
                data-testid="report-motivo-input"
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                rows={4}
                placeholder="Descrivi il motivo…"
                className="w-full bg-transparent border-b border-museo-border text-museo-text text-lg py-3 focus:border-museo-accent focus:outline-none placeholder:text-museo-muted/40 resize-none font-serif"
              />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-[0.2em] text-museo-muted mb-3">Email (opzionale)</label>
              <input
                data-testid="report-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="la-tua@email.it"
                className="w-full bg-transparent border-b border-museo-border text-museo-text text-lg py-3 focus:border-museo-accent focus:outline-none placeholder:text-museo-muted/40"
              />
            </div>
            <button
              data-testid="report-submit-button"
              type="submit"
              disabled={!canSubmit}
              className="w-full bg-museo-accent text-museo-bg px-8 py-4 text-sm tracking-[0.2em] uppercase font-medium hover:bg-museo-text transition-all duration-500 rounded-none md:rounded-sm disabled:opacity-30 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Invia segnalazione"}
            </button>
          </form>
        )}
      </div>
      <Footer />
    </div>
  );
}
